import { Layout } from "../../Layout";

export function DashboardPage() {
    return (
        <h2>Dashboard</h2>
    )
}